const endLiveChat = axios => {
  return axios.put('live-chat');
};

export { endLiveChat };
